import React, { Component } from 'react';
import './../../assets/css/App.css';
import Service from './service';
import Table from './../../component/table/table/Table';
import TableHead from './../../component/table/table/TableHead';
import TableBody from './../../component/table/table/TableBody';
import TableSearchHeader from './../../component/table/table/TableSearchHeader';
import TablePagination from './../../component/table/pagination';
import DatePicker from './../../component/datePicker';
import InputSearchField from './../../component/inputSearchField';
import AdHocViewEnum from './adHocViewEnum';

class TableView extends Component {
    constructor() {
        super();
        // setting default attribute values
        this.currentPage = 0;
        this.createdDateStart = "";
        this.createdDateEnd = "";
        this.searchUpdaterInputFieldValue = "";
        this.searchUserInputFieldValue = "";
        this.viewType = AdHocViewEnum.MANUALACCOUNTBALANCE;
        this.tableHeaderColumnList = [
            { columnName: "User Account Id", key: "userAccountId"},
            { columnName: "Updater Name", key: "updaterName"},
            { columnName: "Updater AccountId", key: "updaterAccountId"},
            { columnName: "Reason", key: "reason"},
            { columnName: "Total for Reason", key: "totalForReason"},
            { columnName: "Total for All Reason", key: "totalForAllReasons"},
        ]
    }

    // START private methods
    _callServiceFetch(page) {
        this.setState({
            showMask: true
        });

        var searchParams = this._createSearchParamsObject();
        Service.fetchAdHocReport(page, searchParams, this.viewType).finally(() => {
            this.setState({ showMask: false });
        });
    }

    _callServiceDownloadFile() {
        var searchParams = this._createSearchParamsObject();
        Service.downloadAdHocReport(searchParams, this.viewType);
    }

    _createSearchParamsObject(page) {
        var searchParams = {};
        searchParams.createdDateStart = this.createdDateStart;
        searchParams.createdDateEnd = this.createdDateEnd;
        searchParams.searchUpdaterId = this.searchUpdaterInputFieldValue;
        searchParams.searchUserId = this.searchUserInputFieldValue;

        return searchParams;
    }
    // END private methods

    state = {
        emptyTableMessage: 'No data can be found',
        tableHeaderTitle: "Ad Hoc Manual Account Balance",
        pagingMetadata: [],
        responseTableData: {},
        firstColumnName : "Date",
        firstColumnKey : "createdDate",
        showMask: false
    }

    componentDidMount () {
        var fetchEventForResultData = Service.getEventSignal(this.viewType);
        fetchEventForResultData.add((data) => {
            this.setState({
                responseTableData: data,
                pagingMetadata: data.pagingMetadata
            });
        });
    }

    onStartDateFieldChange = (value) => {
        this.createdDateStart = value;
    };

    onEndDateFieldChange = (value) => {
        this.createdDateEnd = value;
    };

    onSearchFieldChange = (value) => {
        this.searchInputFieldValue = value;
    };

    // table actions
    searchButtonAction = () => {
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToPage = (e) => {
        e.preventDefault();
        var page = e.currentTarget.attributes.getNamedItem('data-page').value;
        this.currentPage = Number(page);
        this._callServiceFetch(page);
    };

    goForwardToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 0) {
            this.currentPage = this.currentPage + 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    goBackToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    jumpToFirstPage = (e) => {
        e.preventDefault();
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToLastPage = (e) => {
        e.preventDefault();
        this.currentPage = Number(this.state.pagingMetadata.pageCount);
        this._callServiceFetch(this.currentPage);
    };

    downloadFileAction = () => {
        this._callServiceDownloadFile();
    };

    onUpdaterSearchFieldChange = (value) => {
        this.searchUpdaterInputFieldValue = value;
    };

    onUserSearchFieldChange = (value) => {
        this.searchUserInputFieldValue = value;
    };

    render() {
        return (
            <div>
                <Table>
                    <TableSearchHeader
                        headerClassName = {"fa fa-credit-card"}
                        tableHeaderTitle = {this.state.tableHeaderTitle}
                        searchButtonAction = {this.searchButtonAction}
                        downloadFileAction = {this.downloadFileAction}
                        type = "adHocReport"
                    >
                        <InputSearchField
                            fieldId = "adHocUpdaterAccountIdSearchField"
                            placeHolderText = "Search Updater By Account ID"
                            onChange = {this.onUpdaterSearchFieldChange}
                        />
                        <InputSearchField
                            fieldId = "adHocUserAccountIdSearchField"
                            placeHolderText = "Search User by Account Id"
                            onChange = {this.onUserSearchFieldChange}
                        />
                        <DatePicker
                            fieldId = "adHocManualAccountBalanceDatePickerStart"
                            placeHolderText = "Created Start Date"
                            onChange = {this.onStartDateFieldChange}
                            fieldType = "startDate"
                        />
                        <DatePicker
                            fieldId = "adHocManualAccountBalanceDatePickerEnd"
                            placeHolderText = "Created End Date"
                            onChange = {this.onEndDateFieldChange}
                            fieldType = "endDate"
                        />
                    </TableSearchHeader>
                   <TableHead
                       tableHeaderColumnList = {this.tableHeaderColumnList}
                       type = "adHocReport"
                   />
                   <TableBody
                       tableDataResults = {this.state.responseTableData.results}
                       tableHeaderColumnList = {this.tableHeaderColumnList}
                       type = "adHocReport"
                       showMask = {this.state.showMask}
                   >

                   </TableBody>
                    <TablePagination
                        pagingMetadata={this.state.pagingMetadata}
                        jumpToPage={this.jumpToPage}
                        goForwardToPage={this.goForwardToPage}
                        goBackToPage={this.goBackToPage}
                        jumpToFirstPage={this.jumpToFirstPage}
                        jumpToLastPage={this.jumpToLastPage}>
                    </TablePagination>
                </Table>
            </div>
        );
    }
}

export default TableView;
